import { createContext } from 'react';
import { Deal } from '~/types/deal';
import { UserDiscussionStatus } from '~/types/user';

export type PDPContextType = {
  deal: Deal;
  galleryRef?: React.RefObject<HTMLDivElement>;
  userStatus?: UserDiscussionStatus;
  showTimer?: boolean;
  scZoneVariant?: string;
  isDirectToCheckout?: boolean;
};

export const PDPContext = createContext({
  deal: {} as Deal,
  galleryRef: {} as React.RefObject<HTMLDivElement>,
  userStatus: {} as UserDiscussionStatus,
  showTimer: false,
  scZoneVariant: 'disabled',
  isDirectToCheckout: false,
} as PDPContextType);
